/**
 * Генерация списка годов от 1970 до текущего года
 */
export const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 1970;
  const years = [];

  for (let year = currentYear; year >= startYear; year--) {
    years.push({
      value: year.toString(),
      label: year.toString(),
    });
  }

  return years;
};

/**
 * Генерация списка годов для окончания (от 1970 до 2030)
 * включая вариант "По настоящее время"
 */
export const generateEndYearOptions = (startYear?: string | null) => {
  const currentYear = new Date().getFullYear();
  const start = startYear ? parseInt(startYear) : 1970;
  const years = [];

  // Годы от текущего до стартового или 1970
  for (let year = currentYear; year >= Math.max(start, 1970); year--) {
    years.push({
      value: year.toString(),
      label: year.toString(),
    });
  }

  return years;
};

/**
 * Валидация дат образования
 */
export const validateEducationDates = (
  startYear: string,
  endYear: string,
  testLesson: boolean,
): string | null => {
  if (!startYear) return 'Год поступления обязателен';

  const start = parseInt(startYear);
  const currentYear = new Date().getFullYear();

  if (start < 1970 || start > currentYear) {
    return 'Некорректный год поступления';
  }

  if (!testLesson && !endYear) {
    return 'Год окончания обязателен если не учусь по настоящее время';
  }

  if (endYear && endYear !== 'present') {
    const end = parseInt(endYear);
    if (end < start) {
      return 'Год окончания не может быть раньше года поступления';
    }
    if (end > currentYear + 10) {
      return 'Год окончания слишком далеко в будущем';
    }
  }

  return null;
};
